import React from "react";
import PropTypes from "prop-types";

import { Link } from "react-router-dom";
import { Doughnut } from "react-chartjs-2";
import "chartjs-plugin-datalabels";
import "chartjs-plugin-doughnutlabel";

const DashboardMetrics = ({ calls, isDark }) => {
  let metrics = "";
  if (calls.length) {
    const myHours = calls
      .reduce((total, call) => total + call.actual_hrs, 0)
      .toFixed(2);
    const data = {
      datasets: [
        {
          data: [myHours, 40 - myHours >= 0 ? 40 - myHours : 0],
          backgroundColor: isDark
            ? ["#50accb", "#FFF"]
            : ["#50accb", "#EFEFEF"],
          hoverBorderWidth: 4,
          borderColor: isDark ? "#1a2129" : "#fff",
          hoverBorderColor: isDark ? "#1a2129" : "#fff",
          borderWidth: 4
        }
      ]
    };

    const options = {
      maintainAspectRatio: true,
      responsive: false,
      cutoutPercentage: 65,
      animation: { animateScale: true, animateRotate: true },
      layout: {
        padding: {
          left: 5,
          right: 5
        }
      },
      legend: false,
      tooltips: {
        enabled: false
      },
      plugins: {
        datalabels: {
          display: false
        },
        doughnutlabel: {
          labels: [
            {
              text: myHours,
              font: {
                size: "30",
                family: "Metropolis"
              },
              color: isDark ? "white" : "#333"
            },
            {
              text: "Hours",
              font: {
                size: "15",
                family: "Nunito"
              },
              color: isDark ? "white" : "#333"
            }
          ]
        }
      }
    };
    metrics = (
      <div
        className="content-wrapper"
        style={{
          height: "100%",
          display: "flex",
          justifyContent: "center"
        }}
      >
        <Doughnut height={180} data={data} options={options} />
      </div>
    );
  } else {
    metrics = (
      <div className="content-wrapper" style={{ height: "100%" }}>
        <div className="text-center">
          <h4
            style={{
              textAlign: "center",
              fontFamily: "Open Sans",
              margin: "20px auto",
              display: "flex",
              fontSize: "16px",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            You have not entered in time for this week.
          </h4>
          <Link to="/app/timesheet">Go To Timesheet</Link>
        </div>
      </div>
    );
  }

  return metrics;
};

DashboardMetrics.propTypes = {
  calls: PropTypes.array,
  isDark: PropTypes.bool
};

export default DashboardMetrics;
